
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import useUserStore from '../store/useUserStore';

export default function Sidebar() {
    const { user } = useUserStore();
    const [activeIndex, setActiveIndex] = useState(0);
    const [sidebarOption, setSidebarOption] = useState([
        {
            "icon": "menu-icon",
            "navigation": "/dashboard",
            "title": "Dashboard"
        },
        {
            "icon": "menu-icon",
            "navigation": "/company",
            "title": "Company"
        },
        {
            "icon": "menu-icon",
            "navigation": "/company-details",
            "title": "Company Details"
        },
        {
            "icon": "menu-icon",
            "navigation": "/registration",
            "title": "User Registration"
        },

        {
            "icon": "menu-icon",
            "navigation": "/badge",
            "title": "Badge"
        },
        {
            "icon": "menu-icon",
            "navigation": "/send-email-setting",
            "title": "Email Notification"
        },

        {
            "icon": "menu-icon",
            "navigation": "/s3-bucket",
            "title": "S3 Bucket"
        },
        {
            "icon": "menu-icon",
            "navigation": "/copy-record",
            "title": "Record Copy"
        },
        {
            "icon": "menu-icon",
            "navigation": "/send-email",
            "title": "Send Email"
        },
        {
            "icon": "menu-icon",
            "navigation": "/company-default-setting",
            "title": "Company Default Setting"
        },

        {
            "icon": "menu-icon",
            "navigation": "/news",
            "title": "News"
        },
        {
            "icon": "menu-icon",
            "navigation": "/health-check",
            "title": "Health Check"
        },
        {
            "icon": "menu-icon",
            "navigation": "/user-inquiry",
            "title": "User Inquiry"
        },
        {
            "icon": "menu-icon",
            "navigation": "/",
            "title": "Logout"
        }
    ]);
    return (

        <nav className="sidebar sidebar-offcanvas" id="sidebar">
            <div className="sidebar-brand-wrapper d-none d-lg-flex align-items-center justify-content-center fixed-top">
                {/* <a className="sidebar-brand brand-logo" href="index.html"><img src={`${process.env.PUBLIC_URL}/assets/images/logo.svg`} alt="logo" /></a> */}
                {/* <a className="sidebar-brand brand-logo-mini" href="index.html"><img src={`${process.env.PUBLIC_URL}/assets/images/logo-mini.svg`} alt="logo" /></a> */}
            </div>
            <ul className="nav">
                <li className="nav-item profile">
                    <div className="profile-desc">
                        <div className="profile-pic">
                            <div className="count-indicator">
                                <img className="img-xs rounded-circle " src={`${process.env.PUBLIC_URL}/assets/images/faces/face15.jpg`} alt="" />
                                <span className="count bg-success"></span>
                            </div>
                            <div className="profile-name">
                                <h5 className="mb-0 font-weight-normal">{user.name}</h5>
                                <span>{user.role}</span>
                            </div>
                        </div>
                        <a href="#" id="profile-dropdown" data-bs-toggle="dropdown"><i className="mdi mdi-dots-vertical"></i></a>
                        <div className="dropdown-menu dropdown-menu-right sidebar-dropdown preview-list" aria-labelledby="profile-dropdown">
                            <a href="#" className="dropdown-item preview-item">
                                <div className="preview-thumbnail">
                                    <div className="preview-icon bg-dark rounded-circle">
                                        <i className="mdi mdi-cog text-primary"></i>
                                    </div>
                                </div>
                                <div className="preview-item-content">
                                    <p className="preview-subject ellipsis mb-1 text-small">Account settings</p>
                                </div>
                            </a>
                            <div className="dropdown-divider"></div>
                            <a href="#" className="dropdown-item preview-item">
                                <div className="preview-thumbnail">
                                    <div className="preview-icon bg-dark rounded-circle">
                                        <i className="mdi mdi-onepassword  text-info"></i>
                                    </div>
                                </div>
                                <div className="preview-item-content">
                                    <p className="preview-subject ellipsis mb-1 text-small">Change Password</p>
                                </div>
                            </a>
                            <div className="dropdown-divider"></div>
                            <a href="#" className="dropdown-item preview-item">
                                <div className="preview-thumbnail">
                                    <div className="preview-icon bg-dark rounded-circle">
                                        <i className="mdi mdi-calendar-today text-success"></i>
                                    </div>
                                </div>
                                <div className="preview-item-content">
                                    <p className="preview-subject ellipsis mb-1 text-small">To-do list</p>
                                </div>
                            </a>
                        </div>
                    </div>
                </li>
                {/* <li className="nav-item nav-category">
                    <span className="nav-link">Navigation</span>
                </li> */}
                {
                    sidebarOption.map((obj, index) => {
                        return (<li
                            className={`nav-item menu-items ${activeIndex === index ? 'active' : ''}`}
                            key={index}
                            onClick={() => setActiveIndex(index)}>
                            <Link to={obj.navigation} className="nav-link" >
                                <span className={obj.icon}>
                                    <i className="mdi mdi-speedometer"></i>
                                </span>
                                <span className="menu-title">{obj.title}</span>
                            </Link>
                        </li>)
                    })
                }
            </ul>
        </nav>

    )
}